import PreProvisioningTable from './pre-provisioning-table';

export default PreProvisioningTable;
